import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedHeartFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M7 .5C2.129.606.496 3.926.496 7.246c0 3.375 1.688 6.75 6.75 6.75 1.953 0 3.403-.502 4.448-1.313L14.51 15.5l.99-.99-2.822-2.822c.89-1.175 1.277-2.673 1.315-4.188h-1.4c-.04 1.377-.414 2.61-1.149 3.49-.742.891-2.003 1.607-4.198 1.607-2.194 0-3.455-.716-4.197-1.606-.78-.935-1.153-2.265-1.153-3.744s.373-2.81 1.153-3.745C3.762 2.646 4.957 1.952 7 1.9z"
                        fill="currentColor"
                    />
                    <path
                        d="m11.622 5.68.108.065.108-.064c.56-.335 1.202-.72 1.739-1.153C14.23 4 14.73 3.4 14.73 2.734c0-1.424-1.909-2.148-3-.591-.99-1.413-2.653-1.01-2.952.198q-.046.184-.047.393c0 1.214 1.651 2.204 2.891 2.947"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierOutlinedHeartFilledSize16Glyph.displayName = 'MagnifierOutlinedHeartFilledSize16Glyph';
